import React from 'react'

import { Formik } from 'formik'

import { Col, Form, Row } from '_zari/core'

import { MonedasConstant, AfectacionesCompraConstant, OrigenesContabilidadConstant, AfectacionesVentaConstant } from 'constants/index'

import { IdGen, RounderUtil } from 'utils'

import * as FormGroups from './formGroups'

const ResumenContosSection = ({ innerRef, detalles, iOrigen }) => {
  const [keyFormik, setKeyFormik] = React.useState(IdGen.newId())

  const formInitialValues = React.useMemo(() => {
    setKeyFormik(IdGen.newId())

    let importeGravado = 0
    let importeExonerado = 0
    let importeExportacion = 0
    let importeInafecto = 0
    let importeNoGravado = 0
    let importeOtros = 0
    let importeRh = 0
    let importeIgv = 0
    let importeIsc = 0
    let importeTotal = 0

    if (iOrigen === OrigenesContabilidadConstant.COMPRAS) {
      for (let i = 0; i < detalles.length; i++) {
        const element = detalles[i]

        switch (element.tipoAfectacion) {
          case AfectacionesCompraConstant.GRAVADO_A_GRAVADO:
            importeGravado = RounderUtil.round(importeGravado + element.importe)
            break

          case AfectacionesCompraConstant.GRAVADO_A_NO_GRAVADO:
            importeGravado = RounderUtil.round(importeGravado + element.importe)
            break

          case AfectacionesCompraConstant.NO_GRAVADO:
            importeNoGravado = RounderUtil.round(importeNoGravado + element.importe)
            break

          case AfectacionesCompraConstant.OTROS:
            importeOtros = RounderUtil.round(importeOtros + element.importe)
            break

          case AfectacionesCompraConstant.GRAVADO_A_AMBOS:
            importeGravado = RounderUtil.round(importeGravado + element.importe)
            break

          case AfectacionesCompraConstant.RECIBO_HONORARIOS:
            importeRh = RounderUtil.round(importeRh + element.importe)
            break

          case AfectacionesCompraConstant.ISC:
            importeIsc = RounderUtil.round(importeIsc + element.importe)
            break

          default:
            break
        }
      }

      importeIgv = RounderUtil.round(importeGravado * 0.18)
      importeTotal = RounderUtil.round(importeGravado + importeNoGravado + importeOtros + importeIgv + importeRh + importeIsc)
    } else {
      for (let i = 0; i < detalles.length; i++) {
        const element = detalles[i]

        switch (element.tipoAfectacion) {
          case AfectacionesVentaConstant.GRAVADO:
            importeGravado = RounderUtil.round(importeGravado + element.importe)
            break

          case AfectacionesVentaConstant.EXONERADO:
            importeExonerado = RounderUtil.round(importeExonerado + element.importe)
            break

          case AfectacionesVentaConstant.INAFECTO:
            importeInafecto = RounderUtil.round(importeInafecto + element.importe)
            break

          case AfectacionesVentaConstant.OTROS:
            importeOtros = RounderUtil.round(importeOtros + element.importe)
            break

          case AfectacionesVentaConstant.EXPORTACION:
            importeExportacion = RounderUtil.round(importeExportacion + element.importe)
            break

          default:
            break
        }
      }

      importeIgv = RounderUtil.round(importeGravado * 0.18)
      importeTotal = RounderUtil.round(importeGravado + importeExonerado + importeInafecto + importeOtros + importeIgv + importeExportacion)
    }

    return {
      importeGravado: importeGravado,
      importeIcbper: 0,
      importeIgv: importeIgv,
      importeIsc: importeIsc,
      importeNoGravado: importeNoGravado,
      importeOtros: importeOtros,
      importeTotal: importeTotal,
      importeExonerado: importeExonerado,
      importeExportacion: importeExportacion,
      importeInafecto: importeInafecto,
      importeRh: importeRh,
      simboloMoneda: MonedasConstant.SOLES
    }
  }, [iOrigen, detalles])

  return (
    <Formik key={keyFormik} initialValues={formInitialValues} innerRef={innerRef}>
      {({ values, errors, touched, isSubmitting, setValues }) => (
        <Form>
          <Row>
            <Col md={2}>
              <FormGroups.ImporteGravadoFormGroup iValue={values.importeGravado} />
            </Col>
            {iOrigen === OrigenesContabilidadConstant.COMPRAS ? (
              <>
                <Col md={2}>
                  <FormGroups.ImporteNoGravadoFormGroup iValue={values.importeNoGravado} />
                </Col>
                <Col md={1}>
                  <FormGroups.ImporteIscFormGroup iValue={values.importeIsc} />
                </Col>
              </>
            ) : (
              <>
                <Col md={2}>
                  <FormGroups.ImporteExoneradoFormGroup iValue={values.importeExonerado} />
                </Col>
                <Col md={1}>
                  <FormGroups.ImporteInafectoFormGroup iValue={values.importeInafecto} />
                </Col>
              </>
            )}
            <Col md={1}>
              <FormGroups.ImporteIgvFormGroup
                iError={errors.importeIgv}
                iTouched={touched.importeIgv}
                fIsSubmitting={isSubmitting}
                values={values}
                setValues={setValues}
              />
            </Col>
            <Col md={1}>
              <FormGroups.ImporteRhFormGroup iValue={values.importeRh} />
            </Col>
            <Col md={1}>
              <FormGroups.ImporteOtrosFormGroup iValue={values.importeOtros} />
            </Col>
            <Col md={1}>
              <FormGroups.ImporteIcbperFormGroup iValue={values.importeIcbper} />
            </Col>
            <Col md={1}>
              <FormGroups.SimboloMonedaFormGroup iValue={values.simboloMoneda} />
            </Col>
            <Col md={2}>
              <FormGroups.ImporteTotalFormGroup iValue={values.importeTotal} />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(ResumenContosSection)
